module.exports = __webpack_public_path__ + "img/COLLAR RED.9c04e4d.svg";